import { mergeProps, Show } from 'solid-js';
import { QuoteClose } from '../../components/icons-library/quote-close';
import { QuoteOpen } from '../../components/icons-library/quote-open';
import { QuoteCviIcon } from '../../components/icons-library/quote-cvi';
import { QuoteProps } from './quote-types';
import { resolveLegacyTextColor } from '../../style/theme';

const defaultProps = {};

export const Quote = (componentProps: QuoteProps) => {
    const props = mergeProps(defaultProps, componentProps);

    /* The PDF builder is out of scope for the rebrand, so its branch keeps the legacy
       marks and sizing — PDF output isn't re-flowed by the CVI type scale. */
    if (props.forPdfBuilder) {
        return (
            <div class="flex self-start gap-[0_1.5rem] m-[1rem_0] max-mobile:flex-col">
                <div>
                    <QuoteOpen width={3} />
                </div>
                <div>
                    <p
                        class="font-normal font-atos-regular m-0 mb-[1rem] text-[1.36rem] leading-[150%] tracking-normal text-black min-h-[10rem] flex items-center"
                        innerHTML={props.children}
                    />
                </div>
                <div class="flex items-end justify-end">
                    <QuoteClose width={3} />
                </div>
            </div>
        );
    }

    return (
        <figure class="tablet:mx-auto flex max-w-text-measure flex-col items-start gap-cvi-6 pb-cvi-8 tablet:gap-cvi-8 tablet:pb-cvi-10">
            <QuoteCviIcon class="size-cvi-8 text-cvi-fg-brand tablet:size-cvi-10" />

            <blockquote class="m-0 w-full p-0">
                <p
                    class="heading-4xl font-cvi-regular! leading-heading-5xl! m-0 text-cvi-fg-default"
                    style={{ color: props.color || undefined }}
                    innerHTML={props.children}
                />
            </blockquote>

            {/* Last child — `figcaption` must be the figure's first or last. */}
            <Show when={props.source}>
                <figcaption class="body-lg font-cvi-regular w-full text-right text-cvi-fg-muted">
                    <span innerHTML={props.source} />
                </figcaption>
            </Show>
        </figure>
    );
};

Quote.parseProps = (atts: any) => {
    return {
        ...atts,
        color: resolveLegacyTextColor(atts.color),
    };
};
